const amountHandler1 = (amount) => amount / 100
// eslint-disable-next-line
const amountHandler2 = (amount) => parseInt(amount * 100)

export default {
  install($Vue) {
    // eslint-disable-next-line
    $Vue.prototype.$amount1 = amountHandler1;
    $Vue.prototype.$amount2 = amountHandler2;
  }
}
